import { SubStatus } from "core-integration/src/store/my-team/types";
import { rgba } from "polished";
import { Flex } from "rebass/styled-components";
import styled, { css } from "styled-components";
import PitchSvg from "../img/rsl-pitch.svg";

const Pitch = styled.div`
  min-height: 330px;
  background-image: url(${PitchSvg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 516px 330px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    min-height: 524px;
    background-size: 820px 524px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    min-height: 690px;
    background-size: 1080px 690px;
  }
`;

export const ElementRow = styled(Flex)`
  max-width: 410px;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-width: 620px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    max-width: none;
  }
`;

export const PitchRow = styled(ElementRow)`
  padding-bottom: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-bottom: 2.8rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-bottom: 4.5rem;
  }
`;

export const PitchUnit = styled.div`
  flex: 1;
  min-height: 7.2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    min-height: 9.6rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    min-height: 11.6rem;
  }
`;

export const PitchElementWrap = styled.div<IWrapStyleProps>`
  width: 6.4rem;
  margin: 0 auto;
  padding: 0.4rem 0;
  border-radius: 0.4rem;
  align-items: stretch;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 10.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 12rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[5]}) {
    width: 14rem;
  }

  ${(props) =>
    (props.variant === "instigator" || props.variant === "target") &&
    css`
      transition: all 0.15s;
      box-shadow: 0 0 0.6rem 0 rgba(0, 0, 0, 0.4);
    `}

  ${(props) =>
    props.variant === "instigator" &&
    css`
      background-color: ${rgba(props.theme.colors.white, 0.6)};
    `}

  ${(props) =>
    props.variant === "target" &&
    css`
      background-color: ${rgba(props.theme.colors.primary, 0.3)};
      box-shadow:
        0 0 0.6rem 0 rgba(0, 0, 0, 0.4),
        inset 0 -3px 0 0 ${props.theme.colors.orange};
    `}

  ${(props) =>
    props.variant === "invalid" &&
    css`
      opacity: 0.6;
    `}
`;

export const StyledPitchElement = styled.div<IPitchElementStyleProps>`
  position: relative;
  margin: auto;
  padding-inline-end: 0.3rem;
  padding-inline-start: 0.3rem;
  text-align: center;
  opacity: ${(props) => (props.isRemoved ? "0.8" : "1")};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-inline-end: 1rem;
    padding-inline-start: 1rem;
  }
`;

export const Controls = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: block;
  }
`;

export const PrimaryControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    top: 0;
    left: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    left: 20px;
  }
`;

export const InfoControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    top: 0;
    right: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    right: 20px;
  }
`;

interface IWrapStyleProps {
  variant?: SubStatus;
}

interface IPitchElementStyleProps {
  isRemoved?: boolean;
}

export default Pitch;
